export const entityName = 'dataStoreProvider';
export const idAttribute = 'dataStoreId';
